<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import Icon from 'dashboard/components-next/icon/Icon.vue';

const props = defineProps({
  header: { type: Object, default: () => ({}) },
  bodyText: { type: String, default: '' },
  footerText: { type: String, default: '' },
  buttons: { type: Array, default: () => [] },
  mediaPreviewUrl: { type: String, default: '' },
});

const { t } = useI18n();

const isMediaHeader = computed(() =>
  ['IMAGE', 'VIDEO', 'DOCUMENT'].includes(props.header?.format)
);

const isTextHeader = computed(
  () => props.header?.format === 'TEXT' && props.header?.text
);

const mediaIcon = computed(() => {
  const icons = {
    IMAGE: 'i-lucide-image',
    VIDEO: 'i-lucide-video',
    DOCUMENT: 'i-lucide-file-text',
  };
  return icons[props.header?.format] || 'i-lucide-image';
});

const buttonIcon = button => {
  if (button.type === 'URL') return 'i-lucide-external-link';
  if (button.type === 'PHONE_NUMBER') return 'i-lucide-phone';
  return 'i-lucide-reply';
};
</script>

<template>
  <div
    class="flex flex-col flex-shrink-0 gap-2 items-center p-6 rounded-xl bg-n-slate-2 outline outline-1 outline-n-weak"
  >
    <p class="text-sm font-medium text-n-slate-11">
      {{ t('INBOX_MGMT.WHATSAPP_TEMPLATES.PREVIEW.LABEL') }}
    </p>
    <div class="w-full max-w-xs p-3 bg-white rounded-lg shadow dark:bg-n-slate-4">
      <div
        v-if="isMediaHeader"
        class="flex justify-center items-center mb-2 w-full h-32 rounded-md bg-n-slate-3"
      >
        <img
          v-if="header.format === 'IMAGE' && mediaPreviewUrl"
          :src="mediaPreviewUrl"
          class="object-cover w-full h-full rounded-md"
          alt=""
        />
        <Icon v-else :icon="mediaIcon" class="size-10 text-n-slate-9" />
      </div>

      <p
        v-if="isTextHeader"
        class="mb-1 text-sm font-semibold break-words text-n-slate-12"
      >
        {{ header.text }}
      </p>

      <p class="text-sm whitespace-pre-wrap break-words text-n-slate-12">
        {{ bodyText || t('INBOX_MGMT.WHATSAPP_TEMPLATES.PREVIEW.EMPTY_BODY') }}
      </p>

      <p v-if="footerText" class="mt-1 text-xs break-words text-n-slate-10">
        {{ footerText }}
      </p>

      <div v-if="buttons.length" class="flex flex-col gap-1 mt-2">
        <div
          v-for="(button, index) in buttons"
          :key="index"
          class="flex gap-1 justify-center items-center py-1.5 text-sm font-medium rounded-md border-t text-n-blue-10 border-n-weak"
        >
          <Icon :icon="buttonIcon(button)" class="size-3.5" />
          {{
            button.text ||
            t('INBOX_MGMT.WHATSAPP_TEMPLATES.PREVIEW.EMPTY_BUTTON')
          }}
        </div>
      </div>
    </div>
  </div>
</template>
